const _ = require('lodash');

function FormValidationService() {
    this._validationErrors = {};
    this._keysToDelete = [];
}

FormValidationService.prototype.validationErrors = function () {
    return this._validationErrors;
};

FormValidationService.prototype.clearFormValidationErrors = function (formName) {
    _.forEach(this._validationErrors, (value, key) => {
        if (key.indexOf(formName) > -1) {
            this.markToDelete(key);
        }
    });

    this.clearAllMarked();
};


FormValidationService.prototype.markToDelete = function (key) {
    if (_.indexOf(this._keysToDelete, key) < 0) {
        this._keysToDelete.push(key);
    }
};

FormValidationService.prototype.clearAllMarked = function () {
    _.forEach(this._keysToDelete, (value, key) =>
        delete this._validationErrors[this._keysToDelete[key]]
    );

    // Clean up
    this._keysToDelete = [];
};


FormValidationService.prototype.clearAllValidationErrors = function () {
    this._validationErrors = {};
};

FormValidationService.prototype.focusSummary = false;

module.exports = FormValidationService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/form-validation-summary/form-validation-summary-service.js
 **/